(function articleScrappedPage() {
  $(() => {

    const $linkListTriggerButton = $('.le-mag-nav-mobile-first');
    const $linkList = $('.le-mag-nav-mobile-cntr');

    const toggleMobileLinklist = () => {
      $linkListTriggerButton.toggleClass('is-open');
      $linkListTriggerButton.siblings($linkList).toggleClass('open');
    };

    $linkListTriggerButton.on('click', () => {
      toggleMobileLinklist();
    });


    const $mobileMenuButton = $('.mobile-table-content');
    const $mobileMenu = $('.table-content');
    const $mobileMenuItem = $('.section-link');

    const toggleMobileMenu = () => {
      $mobileMenu.toggleClass('open');
    };

    $mobileMenuButton.add($mobileMenuItem).on('click', () => {
      toggleMobileMenu();
    });


    $('.section-link').on('click', () => {
      const $this = $(this).attr('href');
      const $headerHeight = $('#header-anchor').height();
      return $('html, body').animate(
        {
          scrollTop: $($this).offset().top - $headerHeight,
        },
        300,
      );
    });

    const $anchorTargets = [];

    $('.links-article .section-link').each((index, elem) => {
      $anchorTargets.push($(elem).attr('href'));
    });

    const targetLinkObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const $targetLink = $(`.section-link.${entry.target.id}`);

        if (entry.isIntersecting) {
          $targetLink.prevAll().addClass('active');
          $targetLink.addClass('active');
        } else {
          $targetLink.nextAll().removeClass('active');
          entry.boundingClientRect.top > 0 && $targetLink.removeClass('active');
        }
      });
    }, {});

    $anchorTargets.forEach((elem) => {
      targetLinkObserver.observe($(elem)[0]);
    });

    if ($('.table-content').length >= 1) {
      const $menu = $('.table-content');
      const $menuPos = $menu.offset().top;
      const $headerHeight = $('#header-anchor').height();
      const $articlePosBottom = $('.article-content').offset().top + $('.article-content').height();

      window.onscroll = function () {
        if (window.scrollY > $menuPos - $headerHeight) {
          $menu.removeClass('fixedBottom').addClass('fixed');
        }
        if (window.scrollY < $menuPos - $headerHeight) {
          $menu.removeClass('fixed');
        }
        if (window.scrollY + $menu.height() > $articlePosBottom) {
          $menu.addClass('fixedBottom');
        }
      };
    }

    const $accordion = $('.accordion-navigation');

    $accordion.on('click', (el) => {
      const $this = $(el.currentTarget);

      $this.toggleClass('active');
      $accordion.not($this).removeClass('active');
    });

    const posElement =
    document.getElementById('iframeId').offsetTop - document.getElementById('header-anchor').offsetHeight;

    const iframeResize = GlobalSite.checkDependency('GlobalSite.iframeResize');
    iframeResize(posElement);
  });
})();
